// Utilities
import { defineStore } from "pinia";
import { restoreUiLanguage } from "@/i18n";
import PersistenceService from "../../services/PersistenceService";

export const useUserStore = defineStore("user", {
  state: () => {
    return {
      userAccessToken:
        PersistenceService.getFromLocalStorage("userAccessToken") || "",
      data: PersistenceService.getFromLocalStorage("user") || "",
    };
  },
  getters: {
    isLoggedIn: (state) => !!state.userAccessToken,
    accessToken: (state) => state.userAccessToken,
    user: (state) => state.data,
    relation: (state) => state.relation,
  },
  actions: {
    login(token, user) {
      restoreUiLanguage(user);
      this.userAccessToken = token;
      this.data = user;
      PersistenceService.writeToLocalStorage("userAccessToken", token);
      PersistenceService.writeToLocalStorage("user", user);
    },
    update(user) {
      restoreUiLanguage(user);
      this.data = user;
      PersistenceService.writeToLocalStorage("user", user);
    },
    logout() {
      this.userAccessToken = null;
      this.data = null;
      PersistenceService.removeFromLocalStorage("userAccessToken");
      PersistenceService.removeFromLocalStorage("user");
    },
  },
});
